export default __webpack_public_path__ + "assets/fonts/489508b851c821c8cf42e86fc88ef8bd.woff";